/* eslint-disable */
const de = {
  common: {
    entity: "Quantum Capital Management S.A.",
    entity_short: "QUANTUM",
    city: "Luxemburg",
    email: "office@qcmlux.com"
  },
  hero: {
    scroll: "Scrollen"
  },
  hero_cinematic: {
    home: {
      eyebrow: "Quantum Capital Management",
      title: "Luxemburger AIFM",
      subtitle: "Verwaltung alternativer Investmentfonds",
      alt: "Luxemburger Finanzviertel Kirchberg zur bürgerlichen blauen Stunde"
    },
    services: {
      eyebrow: "Leistungen",
      title: "Leistungen",
      subtitle: "Institutionelle Anlageverwaltung",
      alt: "Kühle blaugraue Architektur des Luxemburger Finanzviertels zur blauen Stunde"
    },
    legal: {
      eyebrow: "Rechtliches",
      title: "Rechtliches",
      subtitle: "Rechtliche und aufsichtsrechtliche Informationen",
      alt: "Europäisches institutionelles Interieur — Marmorkolonnade in kühler blaugrauer Tonung"
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Kontakt",
      subtitle: "Geschäftssitz und Anfragen",
      alt: "Institutionelle Führungskraft mit Blick auf ein europäisches Finanzviertel im ersten Licht"
    }
  },
  menu: {
    open: "Menü",
    close: "Schließen",
    navigate: "Navigation",
    language: "Sprache",
    lang_note: "Die Website wird derzeit übersetzt. Vorläufige französische und deutsche Fassungen stehen zur Prüfung zur Verfügung.",
    entity: "Quantum Capital Management S.A.",
    nav: {
      home: "Startseite",
      services: "Leistungen",
      legal: "Rechtliches",
      contact: "Kontakt"
    }
  },
  home: {
    eyebrow: "Luxemburg",
    h1_l1: "Quantum Capital",
    h1_l2: "Management S.A.",
    hero_sub: "Luxemburgischer Verwalter alternativer Investmentfonds",
    reg_eyebrow: "Aufsichtsrechtlicher Status",
    reg_body: "Die Quantum Capital Management S.A. ist ein in Luxemburg ansässiger Verwalter alternativer Investmentfonds (AIFM), der institutionelle Anlagestrukturen durch Governance, Portfolioverwaltung, Risikomanagement und aufsichtsrechtliche Kontrolle betreut.",
    services_eyebrow: "Leistungen",
    services_h2: "Governance, Portfolioverwaltung, Risikomanagement und aufsichtsrechtliche Kontrolle.",
    framework_eyebrow: "Institutioneller Rahmen",
    framework_body: "Die luxemburgische Regulierungsarchitektur — verankert im Gesetz vom 12. Juli 2013 und der Richtlinie 2011/61/EU — bietet einen der etabliertesten europäischen Rahmen für die Verwaltung alternativer Investmentfonds. Die Gesellschaft agiert innerhalb dieses Regimes unter der laufenden Aufsicht der CSSF, im Interesse der Anleger und der von ihr betreuten Strukturen.",
    framework_image_alt: "Langer europäischer institutioneller Korridor mit Parkettboden und hohen Fenstern",
    close_image_alt: "Dächer der Luxemburger Altstadt zur tiefen blauen Stunde",
    mid_alt: "Architekturdetail — Marmorsäule mit Messingkante im weichen Morgenlicht",
    bluehour_alt: "Dächer der Luxemburger Altstadt zur tiefen blauen Stunde",
    footprint_eyebrow: "Internationale Präsenz",
    footprint_h2: "Ein luxemburgischer Standort mit Verbindungen zu institutionellen Partnern weltweit.",
    footprint_body: "Von ihrem regulierten Sitz in Luxemburg aus arbeitet die Gesellschaft mit institutionellen Anlegern, Fonds, Dienstleistern und Aufsichtsbehörden in einer definierten Auswahl von Rechtsordnungen zusammen.",
    footprint_map_alt: "Weltkarte mit Markierungen für Luxemburg, Frankreich, Deutschland, die Vereinigten Staaten, China, Katar und die Vereinigten Arabischen Emirate.",
    footprint_caption: "Illustrativ — Rechtsordnungen institutioneller Beziehungen",
    footprint_countries: {
      united_states: "Vereinigte Staaten",
      luxembourg: "Luxemburg",
      france: "Frankreich",
      germany: "Deutschland",
      china: "China",
      qatar: "Katar",
      uae: "Vereinigte Arabische Emirate"
    }
  },
  contact_map: {
    eyebrow: "Präsenz",
    heading: "Wo wir tätig sind",
    subtitle: "Die Gesellschaft unterhält institutionelle Beziehungen an den wichtigsten Finanzplätzen.",
    map_alt: "Weltkarte mit Markierungen für Luxemburg, Frankfurt, Zürich, Paris, Doha, Dubai und Shanghai.",
    caption: "Illustrativ — wesentliche Tätigkeitsgebiete",
    countries: {
      luxembourg: "Luxemburg",
      germany: "Deutschland",
      switzerland: "Schweiz",
      france: "Frankreich",
      qatar: "Katar",
      uae: "Vereinigte Arabische Emirate",
      china: "China"
    }
  },
  services_cards: {
    aifm: {
      eyebrow: "01 / Fondsverwaltung",
      title: "Verwaltung alternativer Investmentfonds",
      line: "Verwaltung alternativer Anlagestrukturen nach luxemburgischem AIFM-Recht und Richtlinie 2011/61/EU.",
      image_alt: "Moderne abstrakte Glasfassade im weichen Morgenlicht"
    },
    portfolio: {
      eyebrow: "02 / Portfolio",
      title: "Portfolioverwaltung",
      line: "Disziplinierte Aufsicht im Einklang mit der Anlagepolitik jedes Fonds und den treuhänderischen Pflichten.",
      image_alt: "Institutionelles Interieurdetail — Schreibtisch und ledergebundene Bände"
    },
    risk: {
      eyebrow: "03 / Risiko",
      title: "Risikomanagement",
      line: "Unabhängiges Rahmenwerk für Markt-, Liquiditäts-, Kontrahenten- und operationelle Risiken.",
      image_alt: "Architekturstudie — Kolonnade mit wiederholten Steinformen"
    },
    governance: {
      eyebrow: "04 / Governance",
      title: "Governance & aufsichtsrechtliche Kontrolle",
      line: "Corporate Governance, CSSF-Berichterstattung, Compliance und Überwachung von Delegationen.",
      image_alt: "Langer institutioneller Korridor mit hellem Kalksteinboden"
    }
  },
  services_page: {
    eyebrow: "Leistungen",
    h1: "Leistungen",
    intro: "Aufsichtsrechtliche Verwaltung, Portfolioüberwachung, Risikomanagement und Governance für luxemburgische alternative Anlagestrukturen.",
    hero_alt: "Ruhiges minimalistisches europäisches institutionelles Interieur",
    detail_alt: "Institutioneller Innenkorridor — Marmorboden und Holzvertäfelung",
    sections: {
      aifm: {
        number: "01",
        title: "Verwaltung alternativer Investmentfonds",
        body: "Verwaltung alternativer Anlagestrukturen im Einklang mit den anwendbaren luxemburgischen Vorschriften, insbesondere dem luxemburgischen Gesetz vom 12. Juli 2013 über die Verwalter alternativer Investmentfonds und der Richtlinie 2011/61/EU (AIFM-Richtlinie)."
      },
      portfolio: {
        number: "02",
        title: "Portfolioverwaltung",
        body: "Disziplinierte Portfolioaufsicht im Einklang mit den Anlagezielen, der Anlagepolitik und den treuhänderischen Pflichten jedes Fonds, ausgeübt im Interesse der Anleger."
      },
      risk: {
        number: "03",
        title: "Risikomanagement",
        body: "Unabhängiges Risikomanagement-Rahmenwerk, das Markt-, Liquiditäts-, Kontrahenten- und operationelle Risiken abdeckt und mit den Anforderungen der AIFM-Richtlinie im Einklang steht."
      },
      governance: {
        number: "04",
        title: "Governance und aufsichtsrechtliche Kontrolle",
        body: "Corporate Governance, aufsichtsrechtliche Berichterstattung an die CSSF, Compliance-Überwachung, Überwachung der Delegationen und operative Aufsicht über die Tätigkeiten der Verwaltungsgesellschaft."
      }
    }
  },
  contact: {
    eyebrow: "Kontakt",
    h1: "Kontakt",
    intro: "Für professionelle und institutionelle Anfragen.",
    header_alt: "Leerer, gediegener europäischer Sitzungssaal in weichem Tageslicht",
    office_heading: "Geschäftssitz",
    office_address_line1: "1 Haaptstrooss",
    office_address_line2: "L-9806 Hosingen, Luxembourg",
    office_address_placeholder: "1 Haaptstrooss, L-9806 Hosingen, Luxembourg",
    labels: {
      rcs: "RCS Luxembourg",
      rcs_value: "B215925",
      lei: "LEI",
      lei_value: "984500BA00891BF49F35",
      email: "E-Mail",
      telephone: "Telefon",
      placeholder: "[Platzhalter]"
    },
    form: {
      contacting_as: "Ich kontaktiere als",
      first_name: "Vorname",
      last_name: "Nachname",
      organisation: "Organisation",
      email: "Berufliche E-Mail-Adresse",
      country: "Land",
      subject: "Betreff",
      message: "Nachricht",
      submit: "Anfrage senden",
      sending: "Sendet…",
      select_prompt: "Auswählen…",
      required_star: "*",
      char_count: "{count} / 5000",
      consent_prefix: "Ich habe die ",
      consent_link: "Datenschutzerklärung",
      consent_suffix: " gelesen und willige in die Verarbeitung meiner personenbezogenen Daten zum Zwecke der Beantwortung meiner Anfrage ein.",
      errors: {
        required: "Erforderlich.",
        category: "Bitte wählen Sie eine Kategorie.",
        email: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
        message_min: "Bitte geben Sie mindestens 20 Zeichen ein.",
        message_max: "Maximal 5000 Zeichen.",
        consent: "Zur Absendung dieses Formulars ist die Einwilligung erforderlich.",
        rate_limit: "Zu viele Anfragen von dieser Stelle. Bitte versuchen Sie es später erneut.",
        generic: "Ihre Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
        network: "Es ist ein Netzwerkfehler aufgetreten. Bitte versuchen Sie es erneut."
      },
      categories: {
        institutional_investor: "Institutioneller Investor",
        investment_fund: "Investmentfonds",
        regulator: "Aufsichtsbehörde",
        service_provider: "Dienstleister",
        business_partner: "Geschäftspartner",
        general_enquiry: "Allgemeine Anfrage"
      },
      helper: {
        regulator: "Aufsichtsrechtliche Korrespondenz wird an die zuständige Funktion weitergeleitet."
      }
    },
    success: {
      title: "Vielen Dank.",
      body: "Ihre Anfrage ist bei uns eingegangen. Ein Mitglied des Teams wird sich in Kürze bei Ihnen melden.",
      reset: "Weitere Anfrage senden"
    }
  },
  legal: {
    eyebrow: "Rechtliches",
    h1: "Rechtliche und aufsichtsrechtliche Informationen",
    last_updated_label: "Zuletzt aktualisiert",
    toc_label: "Inhalt",
    toc_mobile_label: "Inhalt",
    section_titles: {
      "legal-notice": "Impressum",
      "regulatory-information": "Aufsichtsrechtliche Informationen",
      "privacy": "Datenschutzerklärung",
      "cookies": "Cookie-Richtlinie",
      "complaints": "Beschwerdebearbeitung",
      "conflicts": "Interessenkonflikte",
      "remuneration": "Vergütungspolitik",
      "sfdr": "Nachhaltigkeit (SFDR)",
      "disclaimer": "Haftungsausschluss"
    }
  },
  footer: {
    tagline: "Luxemburgischer Verwalter alternativer Investmentfonds",
    links: {
      legal_notice: "Impressum",
      privacy: "Datenschutzerklärung",
      cookies: "Cookie-Richtlinie",
      contact: "Kontakt"
    },
    group_line: "Mitglied der Quantum-Gruppe",
    copyright: "© {year} Quantum Capital Management S.A. · Luxemburg"
  },
  cookie: {
    copy_prefix: "Diese Website verwendet ausschließlich für den Betrieb erforderliche Cookies. Weitere Informationen finden Sie in unserer ",
    policy_link: "Cookie-Richtlinie",
    copy_suffix: ".",
    dismiss: "Bestätigen"
  },
  draft: {
    text: "Diese deutsche Fassung ist eine vorläufige Übersetzung und steht unter dem Vorbehalt der juristischen Prüfung."
  }
};
export default de;
